import React from 'react';
import { get } from 'lodash';
import NumberUtils from '../../../utils/NumberUtils';

export const CreditCardText = ({ account }) =>
  get(account, 'accountDetails.statementFlag', false) ? (
    <div>
      <dt>Minimum payment</dt>
      <dd className="account-summary__card__min-payment cardsticky__hide">
        {`Minimum payment of ${NumberUtils.appendCurrency(
          '{}',
          account.accountDetails.minimumPayment
        )} due ${account.accountDetails.minimumPaymentDate}`}
      </dd>
    </div>
  ) : null;
